import bloomImg from './images/projects/bloomProject.jpg';
import thamesCityImage from './images/projects/oneThamesCity.jpg';
import woodWharfImage from './images/projects/woodWharf.jpg';

const projects = [
    {
        name: 'Project Bloom Farringdon',
        imageUrl: bloomImg,
    },
    {
        name: 'One Thames City',
        imageUrl: thamesCityImage,
    },
    {
        name: 'Wood Wharf',
        imageUrl: woodWharfImage,
    },
];

// Project Bloom Farringdon- IDSL
// One Thames City- ARK
// Barking Wharf- ARK
// Wood Wharf- Swiftline
// Old Bailey-IDSL
// Camley- Trivetts (ARDMORE)
// Astrazenica- Mace
// Market Fields-
// Station Crescent- PR Morson
// Bankside- IDSL
// Candlewick- Designer Group

const menu = [
    {
        name: 'Our Services',
        link: '/services',
    },
    {
        name: 'Projects',
        link: '/projects',
    },
    {
        name: 'News Feed',
        link: '/news',
    },
    {
        name: 'Contact',
        link: '/contact',
    },
];

export { projects, menu };
